const headerData = [{
		types: "selection",
		columnwidth: 50,
		fixed: 'left'
	}, {
		prop: "CreateTimeTxt",
		label: "填写时间",
		columnwidth: 150,
	}, {
		prop: "ImplantTypeName",
		label: "今/明日",
		columnwidth: 80,
	},
	{
		prop: "Date",
		label: "日期",
		columnwidth: 120,
	},
	{
		prop: "SurgeryTime",
		label: "手术时间",
		columnwidth: 80,
	},
	{
		prop: "HospitalName",
		label: "医院",
		columnwidth: 220,
	},
	{
		prop: "ProvinceName",
		label: "省份",
		columnwidth: 80,
	},
	{
		prop: "CityName",
		label: "城市",
		columnwidth: 80,
	},
	{
		prop: "TechnicalOffices",
		label: "科室",
		columnwidth: 100,
	},
	{
		prop: "Doctor",
		label: "术者",
		columnwidth: 80,
	},
	{
		prop: "InvAddCode",
		label: "产品型号",
		columnwidth: 160,
	},
	{
		prop: "LEVEL3",
		label: "LEVEL3",
		columnwidth: 100,
	},
	{
		prop: "Quantity",
		label: "数量",
		columnwidth: 80,
	},
	{
		prop: "SalesMan",
		label: "销售代表",
		columnwidth: 130,
	},
	{
		prop: "ProvinceMan",
		label: "省级",
		columnwidth: 130,
	},
	{
		prop: "RegionMan",
		label: "大区",
		columnwidth: 110,
	},
	{
		prop: "AreaMan",
		label: "小区",
		columnwidth: 180,
	},
	{
		prop: "CreatorName",
		label: "录入人",
		columnwidth: 130,
	}
];
export default headerData;